const hostname = window && window.location && window.location.hostname;
const protocol=window && window.location &&  window.location.protocol;

const SERVICE_URL=`${protocol}//${hostname}`;
const config = {
  serviceUrl: SERVICE_URL
};

export default config;
